var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiralo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 70,
    viewBox: "0 0 100 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1659_500",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 70
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 70,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1659_500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 41.4479C25 32.8305 31.9858 25.8447 40.6032 25.8447V25.8447V43.7884H25V41.4479Z",
    fill: "url(#paint0_linear_1659_500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6035 30.9224C40.6035 22.0858 47.767 14.9224 56.6035 14.9224H57.7671V43.7883H40.6035V30.9224Z",
    fill: "url(#paint1_linear_1659_500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7671 20C57.7671 11.1634 64.9305 4 73.7671 4H74.9306V27.7882C74.9306 36.6248 67.7672 43.7882 58.9306 43.7882H57.7671V20Z",
    fill: "url(#paint2_linear_1659_500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0113 62.3131H28.0308L27.1133 64.8525H25.5405L29.6691 53.4988H31.3894L35.5016 64.8525H33.9288L33.0113 62.3131ZM32.5854 61.1007L30.5211 55.3338L28.4568 61.1007H32.5854Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8512 54.4163C38.5672 54.4163 38.3269 54.318 38.1303 54.1214C37.9337 53.9248 37.8354 53.6845 37.8354 53.4005C37.8354 53.1166 37.9337 52.8763 38.1303 52.6797C38.3269 52.4831 38.5672 52.3848 38.8512 52.3848C39.1242 52.3848 39.3536 52.4831 39.5393 52.6797C39.7359 52.8763 39.8342 53.1166 39.8342 53.4005C39.8342 53.6845 39.7359 53.9248 39.5393 54.1214C39.3536 54.318 39.1242 54.4163 38.8512 54.4163ZM39.572 55.8744V64.8525H38.0811V55.8744H39.572Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.384 57.3325C44.6462 56.8192 45.0175 56.4205 45.4981 56.1366C45.9896 55.8526 46.5849 55.7106 47.2839 55.7106V57.2506H46.8907C45.2196 57.2506 44.384 58.1572 44.384 59.9703V64.8525H42.8931V55.8744H44.384V57.3325Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.228 60.3307C49.228 59.4132 49.4137 58.6104 49.7851 57.9223C50.1564 57.2233 50.6643 56.6827 51.3087 56.3004C51.9641 55.9181 52.6904 55.727 53.4877 55.727C54.2741 55.727 54.9568 55.8963 55.5356 56.2349C56.1145 56.5734 56.5459 56.9994 56.8299 57.5128V55.8744H58.3372V64.8525H56.8299V63.1814C56.535 63.7057 56.0927 64.1426 55.5029 64.4921C54.924 64.8307 54.2468 65 53.4713 65C52.674 65 51.9531 64.8034 51.3087 64.4102C50.6643 64.017 50.1564 63.4654 49.7851 62.7554C49.4137 62.0455 49.228 61.2373 49.228 60.3307ZM56.8299 60.3471C56.8299 59.6699 56.6934 59.0801 56.4203 58.5777C56.1473 58.0753 55.7759 57.693 55.3063 57.4308C54.8475 57.1578 54.3397 57.0213 53.7826 57.0213C53.2256 57.0213 52.7177 57.1523 52.259 57.4145C51.8002 57.6766 51.4343 58.0589 51.1613 58.5613C50.8882 59.0637 50.7517 59.6535 50.7517 60.3307C50.7517 61.0188 50.8882 61.6195 51.1613 62.1329C51.4343 62.6353 51.8002 63.023 52.259 63.2961C52.7177 63.5582 53.2256 63.6893 53.7826 63.6893C54.3397 63.6893 54.8475 63.5582 55.3063 63.2961C55.7759 63.023 56.1473 62.6353 56.4203 62.1329C56.6934 61.6195 56.8299 61.0243 56.8299 60.3471Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1277 52.7288V64.8525H61.6368V52.7288H63.1277Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3644 65C69.5234 65 68.7589 64.8088 68.0708 64.4265C67.3936 64.0443 66.8584 63.5036 66.4652 62.8046C66.0829 62.0946 65.8918 61.2755 65.8918 60.3471C65.8918 59.4296 66.0884 58.6214 66.4816 57.9223C66.8857 57.2124 67.4318 56.6717 68.1199 56.3004C68.808 55.9181 69.578 55.727 70.43 55.727C71.2819 55.727 72.0519 55.9181 72.74 56.3004C73.4281 56.6717 73.9688 57.2069 74.362 57.906C74.7661 58.605 74.9682 59.4187 74.9682 60.3471C74.9682 61.2755 74.7607 62.0946 74.3456 62.8046C73.9415 63.5036 73.3899 64.0443 72.6909 64.4265C71.9919 64.8088 71.2164 65 70.3644 65ZM70.3644 63.6893C70.8996 63.6893 71.4021 63.5637 71.8717 63.3125C72.3414 63.0613 72.7182 62.6844 73.0022 62.182C73.2971 61.6796 73.4445 61.068 73.4445 60.3471C73.4445 59.6262 73.3025 59.0146 73.0186 58.5121C72.7346 58.0097 72.3632 57.6384 71.9045 57.3981C71.4458 57.1469 70.9488 57.0213 70.4136 57.0213C69.8675 57.0213 69.3651 57.1469 68.9063 57.3981C68.4585 57.6384 68.0981 58.0097 67.825 58.5121C67.552 59.0146 67.4154 59.6262 67.4154 60.3471C67.4154 61.0789 67.5465 61.696 67.8086 62.1984C68.0817 62.7008 68.4421 63.0777 68.8899 63.3289C69.3378 63.5692 69.8293 63.6893 70.3644 63.6893Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1659_500",
    x1: 32.8016,
    y1: 25.8447,
    x2: 32.8016,
    y2: 43.7884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD63C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E17341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1659_500",
    x1: 49.1853,
    y1: 14.9224,
    x2: 49.1853,
    y2: 43.7883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75F69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E27A41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1659_500",
    x1: 66.3489,
    y1: 4,
    x2: 66.3489,
    y2: 43.7882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC517D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0434D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiralo);
export default __webpack_public_path__ + "static/media/airalo.e5975a8c6973edcd198737731ed42b09.svg";
export { ForwardRef as ReactComponent };